import moment from 'moment';

export const filterBySets = (songs,numsets)=>{
  console.log('songs in filter: ',songs);
  return new Promise((resolve)=>{
  let setlen= (songs.length>numsets) ? Math.floor(songs.length/numsets) : 0;
  numsets = (songs.length>numsets) ? numsets : songs.length;
  console.log('set length: ',setlen);
  let results = [];
    for(let i=1; i<=numsets; i++){
      for(let x=0; x<setlen; x++){
        let song = songs.pop();
        let item = {};
        if (song){
          item.set=i;
          item.id=song.id;
          item.time=song.time;
          results.push(item);
        }
      }
    }
    console.log('sets: ',results);

    const totalSongs=(tunes)=>{
      let gigtime = [];
      let results=0;
      for (let i=0; i<tunes.length; i++){
        let timeval = tunes[i].time;
        gigtime.push(timeval);
        results+=timeval;
      }
      return results;
    }

    let total = totalSongs(results);

    let temp = moment.duration(total);
    let final;
    if(temp.hours()>0){
      final = temp.hours() + ' hr ' + temp.minutes() + ' min '+ temp.seconds()+' sec';
    }else{
      final = temp.minutes() + ' min '+ temp.seconds()+' sec';
    }
    console.log('TOTAL: ',final);
    const output = {
      final,total,results
    }
    resolve(output);

  });
 }



// WEBPACK FOOTER //
// ./src/js/filterBySets.js